<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent max-width="400">      
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          確定送出
        </v-card-title>
        <v-card-text class="text-left mt-1 pb-0" style="font-weight:600; height:40px; font-size:15px">
          您確定要送出此筆資料嗎 ?
        </v-card-text>
        <v-row justify="center" class="mx-6 pb-1" style="border: 1px solid #000000; border-radius:8px">          
            <v-card-title class="text-h6 pb-1" style="font-weight:800">
              報考身份別提示
            </v-card-title>
            <span class="text-center px-2" style="font-weight:600; font-size:14px">
              請掃描或拍照身心障礙、低收入戶、其他(特殊家庭)證明E-mail檔案到學會Service電子郵件信箱。
            </span>
            <span class="text-center mb-4" style="font-weight:600; font-size:14px; color:#FF5A5A">
              (中低收入戶-不在減免身份範圍。)
            </span>
        </v-row>
        <v-row justify="center" class="mx-6">          
          <v-card-actions class="pl-0 pr-1" style="width:50%">
            <v-btn outlined color="#81C0E2" style="width:100%; height:46px; border-radius:10px" @click="close">
              取消
            </v-btn>
          </v-card-actions>
          <v-card-actions class="pr-0 pl-1" style="width:50%">
            <v-btn outlined color="#FFF" style="width:100%; height:46px; border-radius:10px; background:#81C0E2" @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
        <v-card-text class="text-left mt-1 mb-3" style="font-weight:600; height:20px; font-size:12px">
          *送出成功會以Email傳送報名完成通知
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'SubmitRegistration',
    props:['onSave'],
    data () {
      return {
        active: false,
        onSaveEn: false,
      }
    },
    methods:{
      open(){
        this.active = true
        this.onSaveEn = true
      },
      close(){
        this.active = false
      },
      save(){
        this.onSave()   
        this.close()     
      }
    }
  }
</script>